import React, { useState } from 'react';

const SimpleUploadTest = () => {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setLoading(true);
    setError(null);
    setResult(null);

    try {
      console.log('Starting upload test for file:', file.name);
      
      const formData = new FormData();
      formData.append('design', file);
      formData.append('name', file.name);
      formData.append('category', 'business-cards');
      formData.append('description', 'Simple upload test');

      const response = await fetch('http://localhost:5000/api/test/upload', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        throw new Error(`Upload failed: ${response.statusText}`);
      }

      const uploadResult = await response.json();
      console.log('Upload successful:', uploadResult);
      
      // Test the exact code path that was failing
      const design = uploadResult?.data?.design;
      console.log('Design object:', design);
      console.log('Original file:', design?.originalFile);
      
      if (design?.originalFile) {
        console.log('✅ originalFile exists');
        console.log('URL:', design.originalFile.url);
        console.log('Public ID:', design.originalFile.public_id);
      } else {
        console.log('❌ originalFile is missing');
      }
      
      setResult(uploadResult);
      
    } catch (err) {
      console.error('Upload failed:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h2>Simple Upload Test</h2>
      
      <input
        type="file"
        onChange={handleFileUpload}
        accept="image/*,.pdf"
        disabled={loading}
      />
      
      {loading && <p>Uploading...</p>}
      
      {error && (
        <div style={{ color: 'red', marginTop: '10px' }}>
          <h3>Error:</h3>
          <p>{error}</p>
        </div>
      )}
      
      {result && (
        <div style={{ marginTop: '20px' }}>
          <h3>Upload Successful!</h3>
          <pre style={{ background: '#f5f5f5', padding: '10px', overflow: 'auto' }}>
            {JSON.stringify(result, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};

export default SimpleUploadTest;
